import Theme from 'styles/theme'

import LazyImage from 'components/display/LazyImage'
import Header from 'components/landing/Header'
import { ParagraphSm } from 'components/display/Typography'
import { DesktopOnly, MobileOnly } from 'components/display/Breakpoints'
import { SectionTitle } from '../../section'
import { SectionContainer, PageHeader } from '../styles'
import { headerImage, headerText } from '../content'

interface HeaderSectionProps {
  openChat: Function
}

const HeaderSection = ({ openChat }: HeaderSectionProps) => {
  return (
    <>
      <DesktopOnly breakpoint="md">
        <Header
          h1Text={headerText.label}
          h2Text={
            <>
              We love hearing <br />
              from you
            </>
          }
          h3Text={headerText.subtitle}
          ctaInner="Start a chat"
          onCtaClick={() => openChat()}
          backgroundColour={Theme?.['-ds-neutral-200']?.value}
        >
          <LazyImage
            data-src={headerImage.large.url}
            data-srcset={`
              ${headerImage.medium.url} ${headerImage.medium.width}w,
              ${headerImage.large.url} ${headerImage.large.width}w,
              ${headerImage.hero.url} ${headerImage.hero.width}w,
            `}
            preload
          />
        </Header>
      </DesktopOnly>

      <MobileOnly breakpoint="md">
        <SectionContainer style={{ marginBottom: 0 }}>
          <SectionTitle>{headerText.label}</SectionTitle>
          <PageHeader>{headerText.title}</PageHeader>
          <ParagraphSm>{headerText.subtitle}</ParagraphSm>
        </SectionContainer>
      </MobileOnly>
    </>
  )
}

export default HeaderSection
